(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;
        
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resin-calculator"] && !Shopify.designMode) return;
  try {
    
    // make sure this is ordered from smallest to largest
    // {
    //   'product': '8oz',  // product name
    //   'ounces': '8',  // product size in ounces
    //   'image': 'https://ccmo23.wpengine.com/wp-content/uploads/2019/03/artist-8oz.jpg',  // image of product
    //   'link': 'https://ccmo23.wpengine.com/product/acrylic-pouring-resin-artist-resin-8oz/',  // link to product listing
    // }
    var resin_calculator_artist_coverage = [{
      'product': '8oz',
      'ounces': 8,
      'image': 'https://counterculturediy.com/wp-content/uploads/AR-8oz1.jpeg',
      'link': 'https://counterculturediy.com/product/artist-resin/artist-resin/?attribute_pa_size=8-oz',
    }, {
      'product': '32oz',
      'ounces': 32,
      'image': 'https://counterculturediy.com/wp-content/uploads/Artist-Resin-32-ozKit.jpg',
      'link': 'https://counterculturediy.com/product/artist-resin/artist-resin/?attribute_pa_size=32-oz',
    }, {
      'product': '1 gallon',
      'ounces': 128,
      'image': 'https://counterculturediy.com/wp-content/uploads/Artist-Resin-1G-Kit.jpg',
      'link': 'https://counterculturediy.com/product/artist-resin/artist-resin/?attribute_pa_size=1-gal',
    }, {
      'product': '2 gallon',
      'ounces': 256,
      'image': 'https://counterculturediy.com/wp-content/uploads/Artist-Resin-Medium-Viscosity-2G-Kit.jpg',
      'link': 'https://counterculturediy.com/product/artist-resin/artist-resin/?attribute_pa_size=2-gal',
    }];

    var resin_calculator_artist_length_input = document.querySelector('.resin-calculator.resin-calculator-artist .resin-calculator-inputs .resin-calculator-length');
    var resin_calculator_artist_width_input = document.querySelector('.resin-calculator.resin-calculator-artist .resin-calculator-inputs .resin-calculator-width');
    var resin_calculator_artist_units_select = document.querySelector('.resin-calculator.resin-calculator-artist .resin-calculator-inputs .resin-calculator-units');

    var resin_calculator_artist_button = document.querySelector('.resin-calculator.resin-calculator-artist .resin-calculator-inputs .resin-calculator-calculate');
    var resin_calculator_artist_area;
    var resin_calculator_artist_volume;

    var resin_calculator_artist_errors_view = document.querySelector('.resin-calculator.resin-calculator-artist .resin-calculator-errors');

    var resin_calculator_artist_outputs_view = document.querySelector('.resin-calculator.resin-calculator-artist .resin-calculator-outputs');
    var resin_calculator_artist_gallons = document.querySelector('.resin-calculator.resin-calculator-artist .resin-calculator-outputs .resin-calculator-gallons');
    var resin_calculator_artist_ounces = document.querySelector('.resin-calculator.resin-calculator-artist .resin-calculator-outputs .resin-calculator-ounces');
    var resin_calculator_artist_liters = document.querySelector('.resin-calculator.resin-calculator-artist .resin-calculator-outputs .resin-calculator-liters');
    var resin_calculator_artist_milliliters = document.querySelector('.resin-calculator.resin-calculator-artist .resin-calculator-outputs .resin-calculator-milliliters');

    var resin_calculator_artist_product_view = document.querySelector('.resin-calculator.resin-calculator-artist .resin-calculator-outputs .resin-calculator-product');
    var resin_calculator_artist_product_link = document.querySelector('.resin-calculator.resin-calculator-artist .resin-calculator-outputs .resin-calculator-product .resin-calculator-product-link');
    var resin_calculator_artist_product_image = document.querySelector('.resin-calculator.resin-calculator-artist .resin-calculator-outputs .resin-calculator-product .resin-calculator-product-image');
    var resin_calculator_artist_product_name = document.querySelector('.resin-calculator.resin-calculator-artist .resin-calculator-outputs .resin-calculator-product .resin-calculator-product-name');
    var resin_calculator_artist_product_coverage = document.querySelector('.resin-calculator.resin-calculator-artist .resin-calculator-outputs .resin-calculator-product .resin-calculator-product-coverage');

    function resin_calculator_artist_round(value, decimals) {
      decimals = decimals === undefined ? 0 : decimals;
      value *= Math.pow(10, decimals);
      value = Math.round(value);
      value /= Math.pow(10, decimals);
      return value;
    }

    function resin_calculator_artist_cm_to_in(value) {
      /* centimeters to inches */
      return value / 2.54;
    }

    function resin_calculator_artist_sq_in_to_oz(value) {
      /* square inches to resin ounces */
      return (value / 144) * (64 / 15);
    }

    function resin_calculator_artist_oz_to_sq_ft(value) {
      /* resin ounces to square feet */
      return value * 15 / 64;
    }

    function resin_calculator_artist_oz_to_gallons(value) {
      /* fluid ounces to gallons */
      return value / 128;
    }

    function resin_calculator_artist_oz_to_liters(value) {
      /* fluid ounces to liters */
      return value / 33.814;
    }

    function resin_calculator_artist_oz_to_milliliters(value) {
      /* fluid ounces to milliliters */
      return value * 29.574;
    }

    resin_calculator_artist_button.addEventListener('click', function() {
      // hide outputs
      resin_calculator_artist_errors_view.style.display = 'none';
      resin_calculator_artist_outputs_view.style.display = 'none';
      resin_calculator_artist_product_view.style.display = 'none';

      // calculate coverage area
      resin_calculator_artist_area = resin_calculator_artist_length_input.value * resin_calculator_artist_width_input.value;
      if (resin_calculator_artist_units_select.value == 'cm') {
        // convert inches to centimeters if necessary
        resin_calculator_artist_area = resin_calculator_artist_cm_to_in(resin_calculator_artist_area);
      }
      // calculate resin volume
      resin_calculator_artist_volume = resin_calculator_artist_sq_in_to_oz(resin_calculator_artist_area);

      if (resin_calculator_artist_volume) {
        // show outputs
        resin_calculator_artist_gallons.innerHTML = resin_calculator_artist_round(resin_calculator_artist_oz_to_gallons(resin_calculator_artist_volume), 2);
        resin_calculator_artist_ounces.innerHTML = resin_calculator_artist_round(resin_calculator_artist_volume);
        resin_calculator_artist_liters.innerHTML = resin_calculator_artist_round(resin_calculator_artist_oz_to_liters(resin_calculator_artist_volume), 2);
        resin_calculator_artist_milliliters.innerHTML = resin_calculator_artist_round(resin_calculator_artist_oz_to_milliliters(resin_calculator_artist_volume));
        resin_calculator_artist_outputs_view.style.display = 'block';

        // show best product
        for (var resin_calculator_artist_product = 0; resin_calculator_artist_product < resin_calculator_artist_coverage.length; resin_calculator_artist_product++) {
          if (resin_calculator_artist_coverage[resin_calculator_artist_product]['ounces'] >= resin_calculator_artist_volume || resin_calculator_artist_product == resin_calculator_artist_coverage.length - 1) {
            resin_calculator_artist_product_name.innerHTML = resin_calculator_artist_coverage[resin_calculator_artist_product]['product'];
            resin_calculator_artist_product_link.href = resin_calculator_artist_coverage[resin_calculator_artist_product]['link'];
            resin_calculator_artist_product_image.src = resin_calculator_artist_coverage[resin_calculator_artist_product]['image'];
            resin_calculator_artist_product_coverage.innerHTML = resin_calculator_artist_round(resin_calculator_artist_oz_to_sq_ft(resin_calculator_artist_coverage[resin_calculator_artist_product]['ounces']), 2);
            resin_calculator_artist_product_view.style.display = 'block';
            break;
          }
        }
      } else {
        resin_calculator_artist_errors_view.style.display = 'block';
      }
    });

  } catch(e) { console.error(e); }
})();
})();
